/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseTabRespVo } from './DeliverFeeWarehouseTabRespVo';
import {
    DeliverFeeWarehouseTabRespVoFromJSON,
    DeliverFeeWarehouseTabRespVoFromJSONTyped,
    DeliverFeeWarehouseTabRespVoToJSON,
    DeliverFeeWarehouseTabRespVoToJSONTyped,
} from './DeliverFeeWarehouseTabRespVo';

/**
 * 
 * @export
 * @interface ResponseListDeliverFeeWarehouseTabRespVo
 */
export interface ResponseListDeliverFeeWarehouseTabRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListDeliverFeeWarehouseTabRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListDeliverFeeWarehouseTabRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<DeliverFeeWarehouseTabRespVo>}
     * @memberof ResponseListDeliverFeeWarehouseTabRespVo
     */
    data?: Array<DeliverFeeWarehouseTabRespVo>;
}

/**
 * Check if a given object implements the ResponseListDeliverFeeWarehouseTabRespVo interface.
 */
export function instanceOfResponseListDeliverFeeWarehouseTabRespVo(value: object): value is ResponseListDeliverFeeWarehouseTabRespVo {
    return true;
}

export function ResponseListDeliverFeeWarehouseTabRespVoFromJSON(json: any): ResponseListDeliverFeeWarehouseTabRespVo {
    return ResponseListDeliverFeeWarehouseTabRespVoFromJSONTyped(json, false);
}

export function ResponseListDeliverFeeWarehouseTabRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListDeliverFeeWarehouseTabRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(DeliverFeeWarehouseTabRespVoFromJSON)),
    };
}

export function ResponseListDeliverFeeWarehouseTabRespVoToJSON(json: any): ResponseListDeliverFeeWarehouseTabRespVo {
    return ResponseListDeliverFeeWarehouseTabRespVoToJSONTyped(json, false);
}

export function ResponseListDeliverFeeWarehouseTabRespVoToJSONTyped(value?: ResponseListDeliverFeeWarehouseTabRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(DeliverFeeWarehouseTabRespVoToJSON)),
    };
}

